import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';
import NormalModal from '../../normal-modal';
import SecondaryButton from '../../secondary-button';

const ConfirmActionModal = ({
  open,
  onCancel,
  onConfirm,
  icon,
  iconBg,
  iconRingColor,
  title,
  description,
  confirmLabel,
  confirmButtonStyle,
}) => {
  const { t } = useTranslation('exercise');
  return (
    <NormalModal
      open={open}
      handleClose={onCancel}
      hideIcon
      backgroundModal="rgba(0,0,0,0.25)"
      containerModalStyle={tw`h-fit w-[40vw] max-w-[400px]! rounded-[12px]! overflow-visible max-lg:[@media(orientation:landscape)]:w-[720px]! max-lg:[@media(orientation:landscape)]:max-w-[90vw]! max-lg:[@media(orientation:portrait)]:w-[92vw]! max-lg:[@media(orientation:portrait)]:max-w-[92vw]!`}
      content={
        <div>
          <div tw="flex flex-col gap-[16px] items-start pt-[24px] px-[24px]">
            <div
              tw="relative rounded-[28px] shrink-0 size-[48px] border-[8px]"
              style={{ backgroundColor: iconBg, borderColor: iconRingColor }}
            >
              <img loading="lazy" decoding="async" alt="" src={icon} tw="absolute left-[10px] top-[10px] size-[20px]" />
            </div>
            <div tw="flex flex-col gap-[4px] items-start w-full">
              <p tw="font-semibold text-[18px] leading-[28px] text-[#2E2E2E] w-full">{title}</p>
              <p tw="text-[14px] leading-[20px] text-gray-text w-full">{description}</p>
            </div>
          </div>
          <div
            dir="ltr"
            tw="flex max-sm:flex-col md:flex-row gap-[12px] items-center pt-[32px] pb-[24px] px-[24px] w-full"
          >
            <button
              tw="flex gap-[8px] items-center justify-center px-[16px] py-[10px] rounded-[6px] border text-[15px] font-medium w-full lg:w-auto"
              css={[
                confirmButtonStyle,
                tw`max-lg:[@media(orientation:landscape)]:flex-1 max-lg:[@media(orientation:landscape)]:w-auto`,
              ]}
              onClick={onConfirm}
            >
              {confirmLabel}
            </button>
            <SecondaryButton
              otherStyle={tw`w-full lg:w-auto rounded-[6px]! py-[10px]! px-[16px]! font-medium! text-[15px]! text-[#2E2E2E] max-lg:[@media(orientation:landscape)]:flex-1! max-lg:[@media(orientation:landscape)]:w-auto!`}
              text={t('settingsModal.cancel')}
              handleClick={onCancel}
            />
          </div>
        </div>
      }
    />
  );
};

export default ConfirmActionModal;
